module.exports = __webpack_public_path__ + "img/4.5c836aa9.png";